// lbl.financial_health
export const financial_health = {
    // Category names
    categories: {
        spend: 'ใช้จ่าย',
        save: 'ออม',
        borrow: 'กู้ยืม',
        plan: 'วางแผน'
    },
    
    // Button text
    buttons: {
        start_quiz: 'เริ่มทำแบบทดสอบ',
        next: 'ต่อไป',
        back: 'ย้อนกลับ',
        view_plankton: 'ได้รับ 50 แพลงก์ตอนแล้ว ดูเลย'
    },
    
    // Overall score content by range
    overall: {
        low: {
            title: 'ยังมีโอกาสพัฒนาได้อีก',
            description: 'เพียงใส่ใจในรายละเอียด การปรับเปลี่ยนพฤติกรรมของคุณเพียงเล็กน้อยในวันนี้ จะนำไปสู่การเปลี่ยนแปลงที่สำคัญในอนาคต เริ่มต้นตัว ยกการดูคะแนนของคุณด้านล่าง เพื่อก้าวสู่เส้นทางอนาคตทางการเงินที่มั่นคงยิ่งขึ้น'
        },
        mid: {
            title: 'คุณจัดการการเงินได้ในเกณฑ์ดี',
            description: 'คุณบริหารการเงินได้ดี ดูคะแนนของคุณด้านล่าง เพื่อทบทวนจุดแข็ง และค้นพบโอกาสในการต่อยอดให้ดียิ่งขึ้น'
        },
        high: {
            title: 'คุณบริหารการเงินได้อย่างยอดเยี่ยม',
            description: 'ดูคะแนนของคุณด้านล่าง เพื่อค้นหาแนวทางในการเสริมสร้างความมั่นคงทางการเงินของคุณให้เติบโตยิ่งขึ้นไป'
        }
    },
    
    // Category content by range
    spend: {
        low: {
            title: 'ยังมีโอกาสพัฒนาได้อีก',
            shortDescription: 'ลองวางแผนการใช้เงิน และหาวิธีลดค่าใช้จ่ายที่ไม่จำเป็น',
            mainTitle: 'ใช้จ่ายอย่างชาญฉลาด',
            mainDescription: 'การใช้จ่ายที่ดีคือการรู้จักใช้ชีวิตให้พอดีกับรายรับ หรือใช้น้อยกว่าที่หามาได้ และพยายามหลีกเลี่ยงการใช้จ่ายผ่านบัตรเครดิตในชีวิตประจำวัน หัวใจสำคัญของสุขภาพทางการเงินที่ดี คือการจ่ายบิลตรงเวลาเสมอ รู้จักจัดลำดับความสำคัญของรายจ่ายที่จำเป็น และมีเงินสำรองไว้สำหรับเหตุการณ์ไม่คาดฝัน ซึ่งทั้งหมดนี้จะทำให้เห็นถึงการวางแผนประมาณที่ดี และความสมดุลในการใช้จ่ายของคุณ'
        },
        mid: {
            title: 'ทำต่อไป',
            shortDescription: 'รักษาวินัยในการใช้งบประมาณ และให้ความสำคัญกับค่าใช้จ่ายที่จำเป็นต่อไป',
            mainTitle: 'ใช้จ่ายอย่างชาญฉลาด',
            mainDescription: 'การใช้จ่ายที่ดีคือการรู้จักใช้ชีวิตให้พอดีกับรายรับ หรือใช้น้อยกว่าที่หามาได้ และพยายามหลีกเลี่ยงการใช้จ่ายผ่านบัตรเครดิตในชีวิตประจำวัน หัวใจสำคัญของสุขภาพทางการเงินที่ดี คือการจ่ายบิลตรงเวลาเสมอ รู้จักจัดลำดับความสำคัญของรายจ่ายที่จำเป็น และมีเงินสำรองไว้สำหรับเหตุการณ์ไม่คาดฝัน ซึ่งทั้งหมดนี้จะทำให้เห็นถึงการวางแผนประมาณที่ดี และความสมดุลในการใช้จ่ายของคุณ'
        },
        high: {
            title: 'ยอดเยี่ยมไปเลย',
            shortDescription: 'ทำได้ดีมาก นิสัยการใช้จ่ายของคุณอยู่ในเกณฑ์ที่สมดุลดีเยี่ยม',
            mainTitle: 'ใช้จ่ายอย่างชาญฉลาด',
            mainDescription: 'การใช้จ่ายที่ดีคือการรู้จักใช้ชีวิตให้พอดีกับรายรับ หรือใช้น้อยกว่าที่หามาได้ และพยายามหลีกเลี่ยงการใช้จ่ายผ่านบัตรเครดิตในชีวิตประจำวัน หัวใจสำคัญของสุขภาพทางการเงินที่ดี คือการจ่ายบิลตรงเวลาเสมอ รู้จักจัดลำดับความสำคัญของรายจ่ายที่จำเป็น และมีเงินสำรองไว้สำหรับเหตุการณ์ไม่คาดฝัน ซึ่งทั้งหมดนี้จะทำให้เห็นถึงการวางแผนประมาณที่ดี และความสมดุลในการใช้จ่ายของคุณ'
        }
    },
    
    save: {
        low: {
            title: 'ยังมีโอกาสเติบโต',
            shortDescription: 'เริ่มสร้างเงินทุนสำรองฉุกเฉินและออมเงินเพื่อเป้าหมายในอนาคตของคุณ',
            mainTitle: 'ออมให้มากขึ้น',
            mainDescription: 'สุขภาพการเงินที่ดีในเรื่องการออม คือการมีวินัยในการออมเงินทุกเดือน และมีเงินเก็บสำรองเพียงพอสำหรับค่าใช้จ่ายอย่างน้อย 3 เดือน ควบคู่ไปกับการออมเพื่อการเกษียณ และเป้าหมายสำคัญอื่นๆ ในชีวิต'
        },
        mid: {
            title: 'ทำต่อไป',
            shortDescription: 'คุณกำลังสร้างนิสัยการออมที่ดี แต่ก็ยังมีโอกาสพัฒนาให้ดีขึ้นได้อีก',
            mainTitle: 'ออมให้มากขึ้น',
            mainDescription: 'สุขภาพการเงินที่ดีในเรื่องการออม คือการมีวินัยในการออมเงินทุกเดือน และมีเงินเก็บสำรองเพียงพอสำหรับค่าใช้จ่ายอย่างน้อย 3 เดือน ควบคู่ไปกับการออมเพื่อการเกษียณ และเป้าหมายสำคัญอื่นๆ ในชีวิต'
        },
        high: {
            title: 'ยอดเยี่ยมไปเลย',
            shortDescription: 'ทำได้ดีมาก ลองยกระดับกลยุทธ์การออม เพื่อเพิ่มความมั่งคั่งทางการเงินที่มากยิ่งขึ้น',
            mainTitle: 'ออมให้มากขึ้น',
            mainDescription: 'สุขภาพการเงินที่ดีในเรื่องการออม คือการมีวินัยในการออมเงินทุกเดือน และมีเงินเก็บสำรองเพียงพอสำหรับค่าใช้จ่ายอย่างน้อย 3 เดือน ควบคู่ไปกับการออมเพื่อการเกษียณ และเป้าหมายสำคัญอื่นๆ ในชีวิต'
        }
    },
    
    borrow: {
        low: {
            title: 'ยังมีโอกาสพัฒนาได้อีก',
            shortDescription: 'ลองลดหนี้ที่มีดอกเบี้ยสูง และชำระคืนให้ตรงเวลา เพื่อสร้างความมั่นคงทางการเงินให้แข็งแกร่งขึ้น',
            mainTitle: 'กู้ยืมอย่างชาญฉลาด',
            mainDescription: 'สุขภาพการเงินที่ดีในเรื่องการกู้ยืมนั้น คือการรู้จักบริหารจัดการหนี้อย่างชาญฉลาด โดยรักษาระดับหนี้สินต่อรายได้ให้อยู่ในเกณฑ์ที่เหมาะสม ชำระคืนตรงเวลา และมีประวัติเครดิตที่ดีอยู่ในระดับ "ดี" ถึง "ยอดเยี่ยม"'
        },
        mid: {
            title: 'ทำต่อไป',
            shortDescription: 'พยายามลดหนี้ของคุณต่อไป รักษาวินัยในการชำระเงิน และมีความรับผิดชอบในการใช้เครดิต',
            mainTitle: 'กู้ยืมอย่างชาญฉลาด',
            mainDescription: 'สุขภาพการเงินที่ดีในเรื่องการกู้ยืมนั้น คือการรู้จักบริหารจัดการหนี้อย่างชาญฉลาด โดยรักษาระดับหนี้สินต่อรายได้ให้อยู่ในเกณฑ์ที่เหมาะสม ชำระคืนตรงเวลา และมีประวัติเครดิตที่ดีอยู่ในระดับ "ดี" ถึง "ยอดเยี่ยม"'
        },
        high: {
            title: 'ยอดเยี่ยมไปเลย',
            shortDescription: 'จัดการหนี้ และมีความรับผิดชอบในการใช้เครดิตได้ดีมาก ทำต่อไป',
            mainTitle: 'กู้ยืมอย่างชาญฉลาด',
            mainDescription: 'สุขภาพการเงินที่ดีในเรื่องการกู้ยืมนั้น คือการรู้จักบริหารจัดการหนี้อย่างชาญฉลาด โดยรักษาระดับหนี้สินต่อรายได้ให้อยู่ในเกณฑ์ที่เหมาะสม ชำระคืนตรงเวลา และมีประวัติเครดิตที่ดีอยู่ในระดับ "ดี" ถึง "ยอดเยี่ยม"'
        }
    },
    
    plan: {
        low: {
            title: 'ยังมีโอกาสเติบโต',
            shortDescription: 'เริ่มวางแผนล่วงหน้ากับแผนประกันที่เหมาะสมจะช่วยสร้างความมั่นคงทางการเงินที่ยั่งยืนให้คุณได้',
            mainTitle: 'วางแผนอย่างรอบคอบ',
            mainDescription: 'สุขภาพทางการเงินที่ดีนั้นครอบคลุมไปถึงอนาคต โดยต้องคำนึงถึงความต้องการต่างๆ เช่น การทำประกัน แผนการเกษียณ และการตัดสินใจทางการเงินเชิงรุก เพื่อบริหารความเสี่ยงและสร้างทุนสำหรับเป้าหมายระยะยาวในชีวิต'
        },
        mid: {
            title: 'ทำต่อไป',
            shortDescription: 'ทำได้ดีมาก ยกระดับแผนประกัน และวางแผนล่วงหน้าต่อไป',
            mainTitle: 'วางแผนอย่างรอบคอบ',
            mainDescription: 'สุขภาพทางการเงินที่ดีนั้นครอบคลุมไปถึงอนาคต โดยต้องคำนึงถึงความต้องการต่างๆ เช่น การทำประกัน แผนการเกษียณ และการตัดสินใจทางการเงินเชิงรุก เพื่อบริหารความเสี่ยงและสร้างทุนสำหรับเป้าหมายระยะยาวในชีวิต'
        },
        high: {
            title: 'ยอดเยี่ยมไปเลย',
            shortDescription: 'แผนการเงินของคุณแข็งแกร่งและมั่นคง ซึ่งจะช่วยให้คุณพร้อมรับมือกับสิ่งที่ไม่คาดฝันได้อย่างดีเยี่ยม',
            mainTitle: 'วางแผนอย่างรอบคอบ',
            mainDescription: 'สุขภาพทางการเงินที่ดีนั้นครอบคลุมไปถึงอนาคต โดยต้องคำนึงถึงความต้องการต่างๆ เช่น การทำประกัน แผนการเกษียณ และการตัดสินใจทางการเงินเชิงรุก เพื่อบริหารความเสี่ยงและสร้างทุนสำหรับเป้าหมายระยะยาวในชีวิต'
        }
    }
};
